import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./definition-list-item.css?inline";

@customElement("eko-definition-list-item")
class DefinitionListItem extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-definition-list-item": DefinitionListItem;
  }
}

export default DefinitionListItem;
